<div class="switch-holder no-focus">
  <div class="switch-btn">
    <input type="checkbox" [id]="'toggle-enable-' + uniqueId" [checked]="active" (click)="toggle(cb.checked)" #cb tabindex="0" />
    <label [for]="'toggle-enable-' + uniqueId" [ngClass]="{ 'toggle-checked': cb.checked }">{{ (cb.checked ? stateLabels.on : stateLabels.off) | translate }}</label>
  </div>
  <div class="switch-status" [ngClass]="{ 'label-Complete': cb.checked }">
    <span *ngIf="cb.checked">{{ stateLabels.on | translate }}</span>
    <span *ngIf="!cb.checked">{{ stateLabels.off | translate }}</span>
    <span class="toggle-status" *ngIf="cb.checked">
      <i class="fa fa-check" aria-hidden="true"></i>
    </span>
    <span class="toggle-status disabled" *ngIf="!cb.checked">
      <i class="fa fa-times" aria-hidden="true"></i>
    </span>
  </div>
</div>
